import {ITheme} from 'contexts/ThemeContext';
import {Platform} from 'react-native';
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  maxSize,
  minSize,
} from 'rn-responsive-styles';

export default (props: ITheme) =>
  CreateResponsiveStyle(
    {
      safeAreaContainer: {},
      container: {flex: 1},
      composerContainer: {
        alignItems: 'center',
      },
      flatList: {
        flex: 1,
        backgroundColor: props.colors.dirtyWhite,
      },
      bottomViewContainer: {
        paddingTop: 16,
        paddingBottom: 16,
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
        width: '100%',
        flexDirection: 'row',
        // justifyContent: 'center',
        alignItems: 'center',
        paddingLeft: 16,
        paddingRight: 16,
      },
      bottomSpacer: {
        width: 24,
      },
      chatTitle: {},
    },
    {
      [minSize(DEVICE_SIZES.SMALL_DEVICE)]: {
        chatTitle: {
          marginTop: 32,
          marginBottom: 20,
          ...props.typography.mulishSemibold,
          fontSize: 22,
          marginLeft: 20,
        },
        safeAreaContainer: {
          height: 669,
          width: 419,
          marginTop: 20,
          borderRadius: 20,
          overflow: 'hidden',
          marginRight: 30,
          backgroundColor: props.colors.white,

          ...(Platform.OS == 'web'
            ? {
                boxShadow: `0px 0px 10px ${props.colors.shadowGrey}`,
              }
            : {}),
        },
        bottomViewContainer: {
          paddingBottom: 36,
        },
        flatList: {
          backgroundColor: props.colors.white,
        },
      },
      [maxSize(DEVICE_SIZES.EXTRA_SMALL_DEVICE)]: {
        safeAreaContainer: {
          flex: 1,
        },
      },
    },
  )();
